import { EventListCardData } from '../../event/event-types';

export const isInPersonEvent = (event?: EventListCardData): boolean => {
    if (!event) {
        return false;
    }
    return event?.isInPerson === true || event?.eventType === 'in-person';
};
